"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _useConfig = _interopRequireDefault(require("./useConfig"));
var _brand = require("../utils/brand");
var _palette = require("../assets/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getSignupRedesignPalette = palette => ({
  secondary: {
    ...palette.secondary,
    main: _palette.SIGNUP_REDESIGN_PALETTE.secondary
  },
  error: {
    ...palette.error,
    main: _palette.SIGNUP_REDESIGN_PALETTE.error
  },
  warning: {
    ...palette.warning,
    main: _palette.SIGNUP_REDESIGN_PALETTE.warning
  },
  success: {
    ...palette.success,
    main: _palette.SIGNUP_REDESIGN_PALETTE.success
  },
  info: {
    ...palette.info,
    main: _palette.SIGNUP_REDESIGN_PALETTE.info
  },
  common: {
    ...palette.common,
    black: _palette.SIGNUP_REDESIGN_PALETTE.black
  },
  grey: {
    ...palette.grey,
    300: _palette.SIGNUP_REDESIGN_PALETTE.grey
  }
});
const useThemeWithConfig = _ref => {
  let {
    theme = {},
    isBackgroundOverridden = true
  } = _ref;
  const {
    brandId,
    brandColor,
    pageBackgroundColor,
    fontSize
  } = (0, _useConfig.default)();
  const isSignupDesignEnabled = (0, _brand.getIsSignupDesignEnabled)(brandId);
  const themeWithConfig = (0, _core.createTheme)({
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        ...theme.palette.primary,
        main: isSignupDesignEnabled ? _palette.SIGNUP_REDESIGN_PALETTE.primary : brandColor?.main || theme.palette.primary.main
      },
      ...(isSignupDesignEnabled && getSignupRedesignPalette(theme.palette)),
      background: {
        ...theme.palette.background,
        default: isBackgroundOverridden && pageBackgroundColor || theme.palette.background.default
      }
    },
    typography: {
      fontFamily: 'inherit',
      fontSize: fontSize || theme.typography.fontSize
    }
  });
  return themeWithConfig;
};
var _default = exports.default = useThemeWithConfig;